import { NgModule } from '@angular/core';
import { CommonService } from "./services/common.service";
import { UserService } from "./services/user.service";
import { RanchService } from "./services/ranch.service";
import { AdminService } from "./services/admin.service";
import { TasksService } from "./services/tasks.service";
import { PrfService } from "./services/prf.service";
import { EmailService } from "./services/email.service";
import { EquipmentService } from './services/equipments.service';
import { ImagesService } from './services/images.service';
import { ServicesCommon } from './services/services-common.service';
import { MappingsService } from "./services/mappings.service";
import { LivestockService } from './services/livestock.service';
import { FinanceService } from './services/finance.service';
import { ClimateService } from './services/climate.service';
import { SurveyService } from './services/survey.service';
import { LRPService } from "./services/lrp.service";
import { ServicesPRFCommon } from "./services/services-prf-common.service";
import { GeneralReportService } from "./services/general-report.service";
import { AuthImagePipe } from "./services/auth-image-pipe/auth-image-pipe";
import { SafeUrlPipe } from "./services/safe-url-pipe/safe-url.pipe";
import { SecurePipe } from "./services/secure-pipe/secure-pipe";
import { TutorialsService } from './services/tutorials-service';
import { LeaseService } from "./services/lease.service";
import { ErrorLogService } from "./services/errorLog.service";

@NgModule({
  declarations: [SafeUrlPipe, AuthImagePipe, SecurePipe
  ],
  imports: [],
  providers: [
    CommonService,
    UserService,
    TutorialsService,
    RanchService,
    PrfService,
    EmailService,
    TasksService,
    AdminService,
    EquipmentService,
    ImagesService,
    ServicesCommon,
    ServicesPRFCommon,
    MappingsService,
    LivestockService,
    LeaseService,
    LRPService,
    FinanceService,
    ClimateService,
    SurveyService,
    GeneralReportService,
    ErrorLogService
  ],
  exports: [SafeUrlPipe, AuthImagePipe, SecurePipe
  ]
})
export class CommonFeModule {
}
